/* StyleMechanics solid-globe compatibility controller.
   Globe.GL owns rendering. This file owns solid material/atmosphere plus accessible zoom UI. */
(function(){
  if(window.__smSolidGlobeControllerV9)return;
  window.__smSolidGlobeControllerV9=true;

  var DEFAULT_ALTITUDE=1.75,MIN_ALTITUDE=.01,MAX_ALTITUDE=6;
  var EARTH='https://cdn.shopify.com/s/files/1/0425/0317/6349/files/sm-earth-cyber-night-blue.jpg?v=1791773514';
  var EARTH_DETAIL='https://cdn.shopify.com/s/files/1/0425/0317/6349/files/sm-earth-cyber-detail-6k-v2.jpg?v=1791777255';
  var VIEW_KEY='sm_globe_view_v1';
  function loadSavedView(){
    try{
      var v=JSON.parse(localStorage.getItem(VIEW_KEY)||'null');
      if(!v||!isFinite(v.lat)||!isFinite(v.lng)||!isFinite(v.altitude))return null;
      return {lat:Number(v.lat),lng:Number(v.lng),altitude:Math.max(DEFAULT_ALTITUDE,Math.min(MAX_ALTITUDE,Number(v.altitude)))};
    }catch(e){return null}
  }
  function saveView(v){
    try{
      if(v&&isFinite(v.lat)&&isFinite(v.lng)&&isFinite(v.altitude))localStorage.setItem(VIEW_KEY,JSON.stringify({lat:Number(v.lat),lng:Number(v.lng),altitude:Math.max(MIN_ALTITUDE,Math.min(MAX_ALTITUDE,Number(v.altitude)))}));
    }catch(e){}
  }

  function latestVisitor(data){
    if(!data||data.source==='shopify_snapshot')return null;
    var rows=(Array.isArray(data.active)?data.active:[]).concat(Array.isArray(data.recent)?data.recent:[]);
    var latest=null;
    rows.forEach(function(v){
      if(!v||v.simulated||v.synthetic||v.ambient||v.is_simulated||v.purchase)return;
      var loc=v.location||{},rawLat=loc.lat,rawLng=loc.lng;
      if(rawLat==null||rawLng==null||String(rawLat).trim()===''||String(rawLng).trim()==='')return;
      var lat=Number(rawLat),lng=Number(rawLng);
      if(!Number.isFinite(lat)||!Number.isFinite(lng)||Math.abs(lat)>90||Math.abs(lng)>180)return;
      var raw=v.created_at||v.createdAt||v.timestamp||v.last_seen||v.lastSeen||v.updated_at||v.updatedAt;
      var numeric=typeof raw==='number'||(typeof raw==='string'&&/^\d+(\.\d+)?$/.test(raw));
      var time=numeric?Number(raw)*(Number(raw)<1e12?1000:1):Date.parse(raw||'');
      if(!Number.isFinite(time)||time<=0)return;
      if(!latest||time>latest.time)latest={lat:lat,lng:lng,time:time};
    });
    return latest;
  }
  function focusLatestVisitor(root,globe,data){
    if(!globe||root.dataset.smLatestVisitorFocus||root.dataset.smManualRotation==='1'||root.classList.contains('sm-bb-active'))return;
    var visitor=latestVisitor(data);
    if(!visitor)return;
    try{
      var view=globe.pointOfView()||{};
      globe.pointOfView({lat:visitor.lat,lng:visitor.lng,altitude:Number(view.altitude)||DEFAULT_ALTITUDE},0);
      root.dataset.smLatestVisitorFocus='done';
    }catch(e){}
  }

  function cleanColor(v,fallback){
    v=String(v||'').trim();
    return /^#[0-9a-f]{3,8}$/i.test(v)?v:fallback;
  }
  function config(root){
    var g=window.__smGlobeColorSettings||{};
    var m=window.__smMapAccentSettings||{};
    var cs=getComputedStyle(root);
    return {
      solid:true,
      water:'#071827',
      lights:typeof g.lights==='number'?Math.max(0,Math.min(1,g.lights)):1,
      atmosphere:true,
      atmosphereColor:'#7FC6FF',
      atmosphereAltitude:.15
    };
  }
  function ensureStyle(){
    if(document.getElementById('sm-globe-zoom-style'))return;
    var s=document.createElement('style');
    s.id='sm-globe-zoom-style';
    s.textContent='.sm-world-live__zoom{position:absolute;z-index:7;right:26px;bottom:60px;display:flex;flex-direction:column;gap:7px}.sm-world-live__zoom button{width:38px;height:38px;padding:0;border:1px solid color-mix(in srgb,var(--sm-aqua) 65%,transparent);border-radius:10px;background:rgba(1,4,5,.84);color:var(--sm-aqua);font:800 22px/1 Arial,sans-serif;display:grid;place-items:center;box-shadow:0 0 14px color-mix(in srgb,var(--sm-aqua) 16%,transparent);cursor:pointer;-webkit-tap-highlight-color:transparent;backdrop-filter:blur(6px)}.sm-world-live__zoom button:active{transform:scale(.96)}@media(max-width:520px){.sm-world-live__zoom{right:20px;bottom:58px}.sm-world-live__zoom button{width:36px;height:36px}}';
    document.head.appendChild(s);
  }
  function ensureControls(root){
    if(root.querySelector('[data-sm-globe-zoom]'))return;
    var wrap=root.querySelector('[data-globe-wrap]');
    if(!wrap)return;
    ensureStyle();
    var box=document.createElement('div');
    box.className='sm-world-live__zoom';box.setAttribute('data-sm-globe-zoom','');box.setAttribute('aria-label','Globe zoom controls');
    var plus=document.createElement('button');plus.type='button';plus.setAttribute('data-sm-globe-zoom-in','');plus.setAttribute('aria-label','Zoom in');plus.textContent='+';
    var minus=document.createElement('button');minus.type='button';minus.setAttribute('data-sm-globe-zoom-out','');minus.setAttribute('aria-label','Zoom out');minus.textContent='−';
    box.appendChild(plus);box.appendChild(minus);wrap.appendChild(box);
  }
  function bindMapScroll(root){
    var wrap=root.querySelector('[data-globe-wrap]');
    if(!wrap||root.__smMapScrollWrap===wrap)return;
    if(root.__smMapScrollCleanup)root.__smMapScrollCleanup();if(root.__smDetailCleanup)root.__smDetailCleanup();
    var oldTouch=wrap.style.touchAction,oldOverscroll=wrap.style.overscrollBehavior;
    wrap.style.touchAction='none';
    wrap.style.overscrollBehavior='contain';
    function contain(e){if(e.cancelable)e.preventDefault();e.stopPropagation()}
    wrap.addEventListener('wheel',contain,{passive:false});
    wrap.addEventListener('touchmove',contain,{passive:false});
    root.__smMapScrollWrap=wrap;
    root.__smMapScrollCleanup=function(){
      wrap.removeEventListener('wheel',contain);
      wrap.removeEventListener('touchmove',contain);
      wrap.style.touchAction=oldTouch;
      wrap.style.overscrollBehavior=oldOverscroll;
      root.__smMapScrollWrap=null;
      root.__smMapScrollCleanup=null;
    };
  }
  function zoomTarget(alt,inward){
    alt=Number(alt);
    if(!isFinite(alt)||alt<=0)alt=DEFAULT_ALTITUDE;
    return inward?Math.min(alt,Math.max(MIN_ALTITUDE,alt*.78)):Math.max(alt,Math.min(MAX_ALTITUDE,alt*1.28));
  }
  function setAltitude(globe,alt,duration){
    try{
      var p=globe.pointOfView()||{};
      var current=Number(p.altitude)||DEFAULT_ALTITUDE;
      alt=Math.max(Math.min(MIN_ALTITUDE,current),Math.min(Math.max(MAX_ALTITUDE,current),Number(alt)||DEFAULT_ALTITUDE));
      globe.pointOfView({lat:typeof p.lat==='number'?p.lat:10,lng:typeof p.lng==='number'?p.lng:-30,altitude:alt},typeof duration==='number'?duration:280);
    }catch(e){}
  }
  function setDefaultZoom(root,globe){
    if(root.dataset.smDefaultZoomV9==='1')return;
    var saved=loadSavedView();
    if(saved){
      try{globe.pointOfView(saved,380)}catch(e){setAltitude(globe,DEFAULT_ALTITUDE,380)}
    }else setAltitude(globe,DEFAULT_ALTITUDE,380);
    root.dataset.smDefaultZoomV9='1';
  }
  function bindControls(root,globe){
    ensureControls(root);
    if(root.__smZoomControlCleanup)root.__smZoomControlCleanup();
    function click(e){
      var b=e.target&&e.target.closest?e.target.closest('[data-sm-globe-zoom-in],[data-sm-globe-zoom-out]'):null;
      if(!b||!root.contains(b))return;
      e.preventDefault();e.stopPropagation();
      try{
        var p=globe.pointOfView()||{},alt=Number(p.altitude)||DEFAULT_ALTITUDE;
        var next=zoomTarget(alt,b.hasAttribute('data-sm-globe-zoom-in'));
        setAltitude(globe,next,280);
        saveView({lat:typeof p.lat==='number'?p.lat:10,lng:typeof p.lng==='number'?p.lng:-30,altitude:next});
      }catch(err){}
    }
    root.addEventListener('click',click);
    root.__smZoomControlCleanup=function(){root.removeEventListener('click',click);root.__smZoomControlCleanup=null};
  }
  function bindManualRotation(root,globe){
    var controls;
    try{controls=globe.controls()}catch(e){return}
    if(!controls||root.__smManualRotationControls===controls)return;
    if(root.__smManualRotationCleanup)root.__smManualRotationCleanup();
    controls.enableRotate=true;
    controls.minDistance=globe.getGlobeRadius()*(1+MIN_ALTITUDE);
    controls.minPolarAngle=.01;
    controls.maxPolarAngle=Math.PI-.01;
    controls.minAzimuthAngle=-Infinity;
    controls.maxAzimuthAngle=Infinity;
    if(controls.touches)controls.touches.ONE=0;
    controls.enableDamping=true;
    controls.dampingFactor=.14;
    controls.rotateSpeed=1;
    function stop(){root.dataset.smManualRotation='1';controls.autoRotate=false}
    function restoreManual(){if(root.dataset.smManualRotation==='1')controls.autoRotate=false}
    function resumeOnReset(e){
      var button=e.target&&e.target.closest?e.target.closest('[data-sm-map-refresh]'):null;
      if(!button||!root.contains(button))return;
      delete root.dataset.smManualRotation;
      controls.autoRotateSpeed=Math.max(.15,Number(controls.autoRotateSpeed)||.15);
      controls.autoRotate=true;
    }
    controls.addEventListener('start',stop);
    root.addEventListener('click',resumeOnReset);
    document.addEventListener('visibilitychange',restoreManual);
    root.__smManualRotationControls=controls;
    root.__smManualRotationCleanup=function(){
      controls.removeEventListener('start',stop);
      root.removeEventListener('click',resumeOnReset);
      document.removeEventListener('visibilitychange',restoreManual);
      root.__smManualRotationControls=null;
      root.__smManualRotationCleanup=null;
    };
    restoreManual();
  }
  function bindDetailTexture(root,globe){
    if(root.__smDetailGlobe===globe){if(root.__smDetailCheck)root.__smDetailCheck();return}
    if(root.__smDetailCleanup)root.__smDetailCleanup();
    var controls=globe.controls(),cancelled=false,requested=false,high=false;
    globe.globeImageUrl(EARTH);
    function check(){
      if(cancelled||requested||high)return;
      try{
        var altitude=Number(globe.pointOfView().altitude);
        if(!isFinite(altitude)||altitude>.8||globe.renderer().capabilities.maxTextureSize<6144||(navigator.deviceMemory&&navigator.deviceMemory<4))return;
        requested=true;
        var image=new Image();image.crossOrigin='anonymous';
        image.onload=function(){image.onload=image.onerror=null;if(cancelled)return;high=true;globe.globeImageUrl(EARTH_DETAIL);root.dataset.smEarthDetail='high'};
        image.onerror=function(){image.onload=image.onerror=null;root.dataset.smEarthDetail='standard'};
        image.src=EARTH_DETAIL;
      }catch(e){}
    }
    controls.addEventListener('change',check);
    root.__smDetailGlobe=globe;root.__smDetailCheck=check;
    root.__smDetailCleanup=function(){cancelled=true;controls.removeEventListener('change',check);root.__smDetailGlobe=null;root.__smDetailCheck=null;root.__smDetailCleanup=null};
    check();
  }
  function startCityPulse(root,globe,c){
    if(root.__smCityPulseRaf)return;
    var start=performance.now();
    function tick(now){
      if(!document.documentElement.contains(root)){root.__smCityPulseRaf=null;return}
      try{
        var mat=globe.globeMaterial();
        if(mat){
          if(mat.map&&mat.emissiveMap!==mat.map)mat.emissiveMap=mat.map;
          var wave=(Math.sin((now-start)/1100)+1)/2;
          mat.emissiveIntensity=(mat.emissiveMap ? .10 : .04)+wave*.006;
        }
      }catch(e){}
      root.__smCityPulseRaf=requestAnimationFrame(tick);
    }
    root.__smCityPulseRaf=requestAnimationFrame(tick);
  }
  function apply(root){
    if(!root)return;
    ensureControls(root);
    bindMapScroll(root);
    var focusWrap=root.querySelector('[data-globe-wrap]');
    if(focusWrap&&!root.__smLatestFocusInputBound){
      root.__smLatestFocusInputBound=true;
      focusWrap.addEventListener('pointerdown',function(){if(!root.dataset.smLatestVisitorFocus)root.dataset.smLatestVisitorFocus='cancelled'},{once:true,passive:true});
    }
    var st=root.__smLiveGlobeState;
    var globe=st&&st.globe;
    if(!globe)return;
    var c=config(root);
    if(c.solid){
      try{bindDetailTexture(root,globe)}catch(e){try{globe.globeImageUrl(EARTH)}catch(err){}}
      try{
        var mat=globe.globeMaterial();
        if(mat){
          if(mat.color){
            mat.color.set('#FFFFFF');
          }
          if(mat.map)mat.emissiveMap=mat.map;
          if(mat.emissive)mat.emissive.set(mat.emissiveMap?'#FFFFFF':'#000000');
          mat.emissiveIntensity=mat.emissiveMap ? .10 : .04;
          mat.roughness=.80;
          mat.needsUpdate=true;
        }
      }catch(e){}
      try{
        if(typeof globe.showAtmosphere==='function')globe.showAtmosphere(c.atmosphere);
        if(c.atmosphere&&typeof globe.atmosphereColor==='function')globe.atmosphereColor(c.atmosphereColor);
        if(c.atmosphere&&typeof globe.atmosphereAltitude==='function')globe.atmosphereAltitude(c.atmosphereAltitude);
      }catch(e){}
      startCityPulse(root,globe,c);
      var label=root.querySelector('[data-globe-mode-label]');
      if(label)label.textContent='GLOBAL VIEW';
      root.dataset.smSolidGlobe='1';
    }
    setDefaultZoom(root,globe);
    focusLatestVisitor(root,globe,window.__smMapLastData);
    bindControls(root,globe);
    bindManualRotation(root,globe);
  }
  function scan(scope){
    (scope||document).querySelectorAll('[data-sm-world-live]').forEach(apply);
  }
  function schedule(scope){
    [80,250,700,1500,3000,5000,8000,12000].forEach(function(ms){setTimeout(function(){scan(scope||document)},ms)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){schedule(document)});else schedule(document);
  document.addEventListener('shopify:section:load',function(e){schedule(e.target)});
  document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('[data-sm-world-live]').forEach(function(root){if(root.__smZoomControlCleanup)root.__smZoomControlCleanup();if(root.__smManualRotationCleanup)root.__smManualRotationCleanup();if(root.__smMapScrollCleanup)root.__smMapScrollCleanup()})});
  document.addEventListener('sm:map-data',function(e){document.querySelectorAll('[data-sm-world-live]').forEach(function(root){var state=root.__smLiveGlobeState;focusLatestVisitor(root,state&&state.globe,e.detail)})});
  document.addEventListener('sm:globe-colors-refresh',function(){schedule(document)});
})();
